import React from 'react';

import Circle from './Circle';
import Wrapper from './Wrapper';

const LoadingIndicator = () => (
  <Wrapper>
    <Circle />
    <Circle className="circle-1" />
    <Circle className="circle-2" />
    <Circle className="circle-3" />
    <Circle className="circle-4" />
    <Circle className="circle-5" />
    <Circle className="circle-6" />
    <Circle className="circle-7" />
    <Circle className="circle-8" />
    <Circle className="circle-9" />
    <Circle className="circle-10" />
    <Circle className="circle-11" />
  </Wrapper>
);

export default LoadingIndicator;
